import * as React from 'react';
import { useQuery } from '@tanstack/react-query';

import { useRegion } from 'common/hooks/region';
import { getPortals } from 'services/clients/credentials';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { QueryKeys } from '../../queries';

interface Props {
  onSelect: (portal: string) => void;
}

/**
 * Renders a grid of selectable portals
 */
export const Portals: React.FC<Props> = (props) => {
  const { onSelect } = props;

  const region = useRegion();
  const portalQuery = useQuery([QueryKeys.PortalListing, region.code], ({ signal }) =>
    getPortals({ portCollectionCode: region.code }, signal)
  );

  const [selected, setSelected] = React.useState<string | null>(null);

  const items = portalQuery.data?.map((portal) => {
    return (
      <ToggleButton
        key={portal.name}
        value={portal.name}
        className="w-[110px] h-[77px] p-2 flexitems-center justify-center"
        title={portal.displayName}
      >
        <div className="space-y-2 flex flex-col items-center justify-center overflow-hidden">
          <img src={portal.logo} alt={portal.displayName} className="w-1/2 pt-2" />
          <a
            href={portal.link}
            target="_blank"
            rel="noreferrer"
            className="text-blue-900 underline truncate w-full"
            onClick={(e) => e.stopPropagation()}
          >
            {portal.displayName}
          </a>
        </div>
      </ToggleButton>
    );
  });

  return (
    <ToggleButtonGroup
      value={selected}
      onChange={(_, value) => {
        setSelected(value);
        onSelect(value);
      }}
      className="grid grid-cols-5 gap-2"
      exclusive
    >
      {items}
    </ToggleButtonGroup>
  );
};
